var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8436_16749)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8436_16749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2009 33.7526C48.5003 33.3029 48.6918 32.7894 48.7603 32.2526C49.0005 31.3287 48.9562 30.3532 48.6334 29.4551C48.3981 28.9865 48.0967 28.5545 47.7386 28.1726C47.1292 27.3223 46.309 26.6474 45.3596 26.2151C44.7121 26.0212 44.033 25.9575 43.361 26.0276C41.0141 26.1527 38.7083 26.6988 36.5524 27.6401C35.8288 27.8752 35.216 28.3688 34.8298 29.0276C34.4122 29.9501 34.8894 31.0151 35.486 31.8251C36.7817 33.5223 38.5857 34.7555 40.6316 35.3426C42.6757 35.9209 44.8338 35.9571 46.8959 35.4476C47.1711 35.3985 47.4284 35.2768 47.6416 35.0951C47.7411 34.9999 47.8039 34.8724 47.8189 34.7352C47.8339 34.5979 47.8002 34.4597 47.7237 34.3451",
    fill: "#1CC67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5554 27.6401C38.7043 26.7014 41.0023 26.1553 43.3416 26.0276C44.0136 25.9575 44.6927 26.0212 45.3402 26.2151C46.2977 26.6441 47.126 27.3193 47.7415 28.1726C48.0996 28.5545 48.401 28.9865 48.6364 29.4551C48.9546 30.3463 48.9988 31.3132 48.7632 32.2301C48.6947 32.7669 48.5033 33.2804 48.2039 33.7301L47.7639 34.3001C47.8021 34.3412 47.8316 34.3896 47.8508 34.4424C47.8701 34.4952 47.8785 34.5514 47.8757 34.6076C47.4806 33.6591 46.8672 32.8186 46.086 32.1551C43.6384 30.1243 40.6107 28.9316 37.4428 28.7501C36.5702 28.6426 35.6847 28.727 34.8477 28.9976C35.2382 28.3552 35.8437 27.8739 36.5554 27.6401Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1811 35.4552C44.353 31.3302 40.152 30.6202 35.5781 33.3252C39.0085 37.3952 43.2095 38.1052 48.1811 35.4552Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2147 34.54C50.1808 34.3424 50.108 34.1537 50.0004 33.9849C49.8928 33.8162 49.7526 33.6708 49.5883 33.5575C49.4252 33.4428 49.2402 33.3636 49.0451 33.3249C48.8499 33.2861 48.6488 33.2887 48.4547 33.3325C48.2576 33.3646 48.0688 33.4363 47.8997 33.5433C47.7306 33.6502 47.5846 33.7902 47.4704 33.955C47.3586 34.1214 47.2812 34.3088 47.2427 34.5059C47.2043 34.703 47.2056 34.9059 47.2466 35.1024C47.2804 35.3 47.3533 35.4887 47.4609 35.6575C47.5685 35.8263 47.7086 35.9716 47.873 36.0849C48.0321 36.2075 48.2171 36.2915 48.4137 36.3305C48.6103 36.3695 48.8131 36.3625 49.0066 36.31C49.2011 36.2759 49.3869 36.2033 49.5534 36.0965C49.7198 35.9896 49.8635 35.8506 49.976 35.6875C50.0904 35.5221 50.1704 35.3353 50.2114 35.1381C50.2524 34.941 50.2535 34.7375 50.2147 34.54Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.128 34.5853C48.8286 34.1348 48.6348 33.622 48.5613 33.0852C48.332 32.1647 48.3787 31.1966 48.6955 30.3027C48.9368 29.8359 49.2404 29.4044 49.5979 29.0202C50.21 28.1726 51.0294 27.4983 51.9768 27.0627C52.6242 26.8689 53.3034 26.8052 53.9753 26.8752C56.3149 27.0065 58.6129 27.555 60.7616 28.4952C61.4865 28.7278 62.1002 29.2221 62.4841 29.8827C62.9017 30.7978 62.4244 31.8702 61.828 32.6727C60.5382 34.3762 58.7363 35.6151 56.6897 36.2052C54.6457 36.7836 52.4877 36.8197 50.4256 36.3103C50.1498 36.2677 49.8915 36.1481 49.6799 35.9652C49.5817 35.8692 49.5198 35.7419 49.5048 35.6051C49.4898 35.4682 49.5227 35.3304 49.5979 35.2152",
    fill: "#1CC67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7616 28.4801C58.6129 27.5399 56.3149 26.9913 53.9753 26.8601C53.3034 26.79 52.6242 26.8538 51.9768 27.0476C51.0294 27.4832 50.21 28.1575 49.5979 29.0051C49.2404 29.3893 48.9368 29.8208 48.6955 30.2876C48.3787 31.1814 48.332 32.1496 48.5613 33.0701C48.6348 33.6068 48.8286 34.1197 49.128 34.5701L49.568 35.1401C49.4912 35.2264 49.451 35.3394 49.4562 35.4551C49.8513 34.5066 50.4647 33.6661 51.2459 33.0026C53.6911 30.9678 56.7203 29.7744 59.8889 29.5976C60.7611 29.4877 61.6466 29.5696 62.4841 29.8376C62.0905 29.192 61.4792 28.7102 60.7616 28.4801Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.582 35.0876C53.5536 30.9726 58.4483 30.8051 63.2655 34.5851C58.7017 38.6876 53.8321 38.8526 48.582 35.0876Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6413 35.3801H54.043V73.8477H62.6413V35.3801Z",
    fill: "#6883D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7649 35.3801H29V73.8477H44.7649V35.3801Z",
    fill: "#9057F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7688 35.3801H44.7656V73.8477H71.7688V35.3801Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6413 35.3801H54.043V73.8477H62.6413V35.3801Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.554 35.3801H34.207V73.8477H39.554V35.3801Z",
    fill: "#78C7D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8436_16749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8436_16749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 48,
    fill: "white",
    transform: "translate(29 26)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.d6880086181166d55b2d7f56a4747a03.svg";
export { ForwardRef as ReactComponent };